export default __webpack_public_path__ + "static/media/save-tick-white.885b9051.svg";